import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import styles from './Accordion.module.css';
import Section from '../Section';
const getInitialOpenSections = (sections) => sections.filter(({ active }) => active).map(({ key }) => key);
const getSectionKeys = (sections) => sections.map((element, index) => (Object.assign(Object.assign({}, element), { key: `section${index}` })));
const Accordion = ({ sections, className, allowMultiple = false, useFadeOnScroll = false }) => {
    const scrollRef = useRef(null);
    const sectionsWithKeys = getSectionKeys(sections);
    const initialOpenSections = getInitialOpenSections(sectionsWithKeys);
    const [activeSectionKeys, setActiveSectionKeys] = useState(allowMultiple ? initialOpenSections : initialOpenSections.slice(0, 1));
    const [fadeBottom, setFadeBottom] = useState(false);
    const [fadeTop, setFadeTop] = useState(false);
    const [fadeStyle, setFadeStyle] = useState('');
    const [scrollTop, setScrollTop] = useState(0);
    useEffect(() => {
        const accordion = scrollRef.current;
        if (accordion) {
            const onScroll = (e) => {
                const target = e.target;
                setScrollTop(target.scrollTop);
                const bottom = target.scrollHeight - target.scrollTop === target.clientHeight;
                setFadeBottom(!bottom);
                setFadeTop(scrollTop >= 10);
            };
            accordion.addEventListener('scroll', onScroll);
            return () => accordion.removeEventListener('scroll', onScroll);
        }
        return undefined;
    }, [scrollTop]);
    useEffect(() => {
        if (scrollRef.current) {
            const isYOverflowing = scrollRef.current.scrollHeight > scrollRef.current.clientHeight;
            if (useFadeOnScroll) {
                if (fadeTop) {
                    setFadeStyle(styles.fadeTop);
                }
                else if (fadeBottom || isYOverflowing) {
                    setFadeStyle(styles.fadeBottom);
                }
                if (fadeTop && fadeBottom) {
                    setFadeStyle(styles.fadeBoth);
                }
            }
        }
    }, [fadeTop, fadeBottom, useFadeOnScroll, scrollRef, activeSectionKeys]);
    if (!sections.length) {
        return null;
    }
    const handleActivate = (sectionKey) => {
        if (allowMultiple) {
            setActiveSectionKeys((prevSectionKeys) => prevSectionKeys.includes(sectionKey)
                ? prevSectionKeys.filter((key) => sectionKey !== key)
                : [sectionKey, ...prevSectionKeys]);
        }
        else {
            setActiveSectionKeys((prevSectionKeys) => prevSectionKeys.includes(sectionKey) ? [] : [sectionKey]);
        }
    };
    return (React.createElement("div", { className: cx(styles.accordion, useFadeOnScroll ? styles.accordionWithHeight : '', fadeStyle, className), ref: scrollRef }, sectionsWithKeys.map((section) => (React.createElement(Section, { key: section.key, className: section.className, sectionKey: section.key, onActivate: () => handleActivate(section.key), active: activeSectionKeys.includes(section.key), headline: section.headline, preview: section.preview, allowMultiple: allowMultiple, onClick: section.onClick }, section.content)))));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map